import React from "react";

import "./difficultyDisplay.css";

interface DifficultyDisplayProps {
    concert: boolean;
}

export default function DifficultyDisplay(props: DifficultyDisplayProps) {
    return <span className={"difficulty-display" + (props.concert ? " concert" : "")}>
        <h5>{props.concert ? "Concert" : "Pedagogic"}</h5>
    </span>
}